import React from "react";
import { StaticImage } from 'gatsby-plugin-image';
import {services, subservices} from "../../../../../constants/services";
import {Row, Col, Container} from "reactstrap";
import Description from "./Description";
import Subservices from "./Subservices";
import { isMobile } from 'react-device-detect';

const verifyIdPicture: string = require("../../../../../assets/images/services/mobile/verifyIdPicture.png").default;
const coSignerPicture: string = require("../../../../../assets/images/services/mobile/coSignerPicture.svg").default;
const eSignPicture: string = require("../../../../../assets/images/services/mobile/eSignPicture.png").default;
const wetSignPicture: string = require("../../../../../assets/images/services/mobile/wetSignPicture.svg").default;
const notaryServicesPicture: string = require("../../../../../assets/images/services/mobile/notaryServicesPicture.svg").default;
const sealedPicture: string = require("../../../../../assets/images/services/mobile/sealedPicture.png").default;
const agentReviewPicture: string = require("../../../../../assets/images/services/mobile/agentReviewPicture.svg").default;

const Services = () => {

  return (
    <React.Fragment>
      <Container>
        <h4 className='services-title text-center mb-2 mt-5'>Our Services</h4>
        <Row className='services' id="verify-id">
          {isMobile ? <img src={verifyIdPicture} className="w-100" alt="Customer making biometric face scan for identity document verification" />
           : <Col sm={12} md={5}>
            <StaticImage src="../../../../../assets/images/services/verifyIdPicture.png" alt="Customer making biometric face scan for identity document verification" placeholder="dominantColor"/>
          </Col>}

          <Col sm={12} md={7} className='description-col ps-5'>
            <Description 
              icon={services.verifyId.icon} 
              title={services.verifyId.title} 
              subtitle={services.verifyId.subtitle} 
              description={services.verifyId.description}
            />
          </Col>

          <Col sm={12} className='my-4 verify-subservice d-flex'>
            <div className="mobile-subservice-wrapper">
              <Subservices 
                picture={subservices.inStore.picture}
                icon={subservices.inStore.icon}
                title={subservices.inStore.title} 
                description={subservices.inStore.description}
              />
              <div className='mx-2 hidden-mobile'></div>
              <Subservices 
                picture={subservices.remote.picture} 
                icon={subservices.remote.icon} 
                title={subservices.remote.title} 
                description={subservices.remote.description}
              />
            </div>
          </Col>
        </Row>
      </Container>

      <div className={!isMobile && "bg-white"}>
        <Container>
          <Row className='services' id="e-sign">
            {isMobile && <img src={eSignPicture} className="w-100" alt="Customers using document verification services on their laptop" />}
            <Col sm={12} md={7} className={!isMobile && 'pe-5'}>
              <Description 
                icon={services.eSign.icon} 
                title={services.eSign.title} 
                subtitle={services.eSign.subtitle} 
                description={services.eSign.description} 
              />
            </Col>
            {!isMobile && <Col sm={12} md={5}>
              <StaticImage src="../../../../../assets/images/services/eSignPicture.png" alt="Customers using document verification services on their laptop" placeholder="dominantColor"/>
            </Col>}
          </Row>
        </Container>
      </div>

      <Container>
        <Row className='services' id="wet-sign">
          {isMobile ? <img src={wetSignPicture} className="w-100" alt="Customer before wet signing a car purchase agreement" /> :  
            <Col sm={12} md={5}>
            <StaticImage src="../../../../../assets/images/services/wetSignPicture.png" alt="Customer before wet signing a car purchase agreement" placeholder="dominantColor"/>
          </Col>}

          <Col sm={12} md={7} className={!isMobile && 'ps-5'}>
            <Description 
              icon={services.wetSign.icon} 
              title={services.wetSign.title} 
              subtitle={services.wetSign.subtitle}
              description={services.wetSign.description} 
            />
          </Col>
        </Row>
      </Container>

      <div className={!isMobile && "bg-white"}>
        <Container>
          <Row className='services' id="notary-and-rush">
            {isMobile && <img src={notaryServicesPicture} className="w-100" alt="Mobile notary shaking hands with remote dealership customer" />}
            <Col sm={12} md={7} className={!isMobile && 'pe-5'}>
              <Description 
                icon={services.notaryServices.icon} 
                title={services.notaryServices.title} 
                subtitle={services.notaryServices.subtitle} 
                description={services.notaryServices.description} 
              />
            </Col>
            {!isMobile && <Col sm={12} md={5}>
              <StaticImage src="../../../../../assets/images/services/notaryServicesPicture.png" alt="Mobile notary shaking hands with remote dealership customer" placeholder="dominantColor"/>
            </Col>}
      
            <Col sm={12} className='rush-subservice my-3'>
              <div className="mobile-subservice-wrapper">
                <Subservices 
                  picture={subservices.rush.picture} 
                  icon={subservices.rush.icon} 
                  title={subservices.rush.title}
                  description={subservices.rush.description}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container>
        <Row className='services' id="co-signer">
          {isMobile ? <img src={coSignerPicture} className="w-100" alt="Signer and co-signer placing wet signatures on car contract" /> : 
          <Col sm={12} md={5}>
            <StaticImage src="../../../../../assets/images/services/coSignerPicture.png" alt="Signer and co-signer placing wet signatures on car contract" placeholder="dominantColor"/>
          </Col>}

          <Col sm={12} md={7} className={!isMobile && 'ps-5'}>
            <Description 
              mobileSpecialDisplay={true} 
              icon={services.CoSigner.icon}
              title={services.CoSigner.title} 
              subtitle={services.CoSigner.subtitle}
              description={services.CoSigner.description} 
            />
          </Col>
        </Row>
      </Container>

      <div className={!isMobile && "bg-white"}>
        <Container>
          <Row className='services' id="sealed">
            {isMobile && <img src={sealedPicture} className="w-100" alt="Mavsign eseal symbol present on all signed car documents" />}
            <Col sm={12} md={7} className={!isMobile && 'pe-5'}>
              <Description 
                mobileSpecialDisplay={true} 
                icon={services.sealed.icon} 
                title={services.sealed.title} 
                subtitle={services.sealed.subtitle} 
                description={services.sealed.description} 
              />
            </Col>
            {!isMobile && <Col sm={12} md={5}>
              <StaticImage src="../../../../../assets/images/services/sealedPicture.png" alt="Mavsign eseal symbol present on all signed car documents" placeholder="dominantColor"/>
            </Col>}
          </Row>
        </Container>
      </div>

      <div className={isMobile && "bg-white mt-4"}>
        <Container>
          <Row className='services' id="agent-review">
            {isMobile ? <img src={agentReviewPicture} className="w-100" alt="Mavsign fraud detection agents verifying uploaded id on computer database" /> : <Col sm={12} md={5}>
              <StaticImage src="../../../../../assets/images/services/agentReviewPicture.png" alt="Mavsign fraud detection agents verifying uploaded id on computer database" placeholder="dominantColor"/>
            </Col>}

            <Col sm={12} md={7} className={!isMobile && 'ps-5'}>
              <Description 
                mobileSpecialDisplay={true} 
                icon={services.agent.icon} 
                title={services.agent.title} 
                subtitle={services.agent.subtitle} 
                description={services.agent.description} 
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}


export default Services;